import { t } from "i18next";

import { ReturnDetails } from "../../returns.types";

interface getDeliveryAndDriverProps {
  returnDetails: ReturnDetails;
}

export const getDeliveryAndDriver = ({
  returnDetails
}: getDeliveryAndDriverProps) => {
  const deliveryZone = returnDetails.deliveryAddress.deliveryZone;
  const deliveryAddressNeighborhood = deliveryZone?.neighborhood;
  const deliveryAddressCity = deliveryZone.city;
  const deliveryAddressCountry = deliveryZone.country;

  const driver = returnDetails.driver;
  const driverName = driver
    ? `${driver?.firstname} ${driver?.lastname}`
    : t("Not assigned");

  const deliveryAddress = `${returnDetails?.deliveryAddress.fullName}\n${returnDetails?.deliveryAddress.phoneNumber}\n${returnDetails?.deliveryAddress.address} ${deliveryAddressNeighborhood} ${deliveryAddressCity} ${deliveryAddressCountry}`;
  const driverDetails = `${driverName}\n${driver?.phoneNumber ?? ""}\n${driver?.plateNumber ?? ""}`;

  return {
    deliveryAddress,
    driverDetails
  };
};
